import React, { Component } from "react";
import { Container, Row, Col, Button, Modal, FormControl } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";



export default class ModalQuarantineDispositionDialog extends Component {

    constructor(props){
      super(props);
      this.state = {
        dispositionReason: null
      }

      this.onReasonOk = this.onReasonOk.bind(this);
    }
  

    onReasonOk(){
      return this.props.onDispositionPostRequest(this.state.dispositionReason);
    }

  render() {

    return (

        <Modal show={this.props.show} onHide={this.props.onVoidCancelRequest}>
        <Modal.Header closeButton>
          <Modal.Title>Quarantined Pallet Disposition</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              <Col>
                <div center="true">
                  How do you want to dispose of this pallet?
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <div center="true">
                  <FormControl
                    as="select"
                    placeholder="dispositionReason"
                    type="dropdown"
                    autoComplete="on"
                    value={this.state.dispositionReason}
                    name="voidReason"
                    onChange={ev =>
                      this.setState({ dispositionReason: ev.target.value })
                    }
                  >
                    {this.props.dispositionReasonList.map(disp => (
                      <option key={disp.value} value={disp.value}>
                        {disp.label}
                      </option>
                    ))}
                  </FormControl>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.onReasonOk}>
            Ok
          </Button>
          <Button variant="secondary" onClick={this.props.onDispositionCancelRequest}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

    );
  }
}



